"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
require("./dialog.css");
const React = tslib_1.__importStar(require("react"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const modal_1 = require("@nbc-design/modal");
const body_1 = require("./body");
const closeBtn_1 = require("./closeBtn");
const footer_1 = require("./footer");
const header_1 = require("./header");
/** Dialogs inform users about a task and can contain critical information, require decisions, or involve multiple tasks. */
exports.Dialog = React.forwardRef(({ appearance = 'dark', children, className, onDialogClose, titleId, dataTest = 'dialog', focusLockProps, triggerClosing = false, }, ref) => {
    const classes = (0, classnames_1.default)('dsc-dialog', className);
    return ((0, jsx_runtime_1.jsx)(modal_1.Modal, { appearance: appearance, className: classes, onModalClose: onDialogClose, titleId: titleId, dataTest: dataTest, focusLockProps: focusLockProps, triggerClosing: triggerClosing, ref: ref, children: children }));
});
exports.Dialog.displayName = 'Dialog';
exports.Dialog.Body = body_1.Body;
exports.Dialog.CloseBtn = closeBtn_1.CloseBtn;
exports.Dialog.Header = header_1.Header;
exports.Dialog.Footer = footer_1.Footer;
exports.default = exports.Dialog;
//# sourceMappingURL=dialog.js.map